
import { DateTime } from "luxon";
import formatDateTime from "../../../../utils/formatDateTime";
import { CategoryWithParts, IPartImage } from './../../../../models/Part';
import { CameraIcon } from "@heroicons/react/24/outline";
import classNames from "../../../../utils/classNames";
import Modal from "../../../../layouts/Modal";
import ImageCarousel from "../../../shared/Images/ImageCarousel";
import { useState } from "react";
import PriceFormat from "../../../../utils/priceFormat";

export default function LeadPartsCategoriesTableSubRow({ categoryWithParts }: { categoryWithParts: CategoryWithParts }) {
  const [partPicturesOpen, setPartPicturesOpen] = useState<boolean>(false);
  const [partPictures, setPartPictures] = useState<IPartImage[]>([]);

  const innerColCss = "flex justify-evenly items-center h-full text-center w-full [&>div]:flex [&>div]:flex-col [&>div]:flex-auto [&>div]:items-center [&>div]:justify-center [&>div]:border-l-2 [&>div]:border-gray-200"


  return (
    <>
      <Modal open={partPicturesOpen} setOpen={setPartPicturesOpen} width={"max-w-7xl"} >
        <ImageCarousel images={partPictures} part />
      </Modal>

      <div key={categoryWithParts.category.id} className="flex flex-col gap-2">

        {(categoryWithParts.parts || [])
          .sort((a, b) => {

            if (!a.soldDate && !b.soldDate) return 0; // If both are not sold, keep original order
            if (!a.soldDate) return 1; // If a is not sold, b comes first
            if (!b.soldDate) return -1; // If b is not sold, a comes first

            //If isInternal, sort by soldDate else sort by created
            //This is leftovers from the old scrape data
            const aDate = a.isInternal ? DateTime.fromISO(a.soldDate).toMillis() : DateTime.fromISO(a.created).toMillis();
            const bDate = b.isInternal ? DateTime.fromISO(b.soldDate).toMillis() : DateTime.fromISO(b.created).toMillis();

            return bDate - aDate; // descending
          })
          .map((part) => {
            //Find image that isThumbnail is true
            const imageUrl = part.images.find((image) => image.isThumbnail === true)?.url;
            return (
              <div key={part.id} className="flex justify-between px-4">

                <div className="w-full flex bg-white border rounded-lg ml-1" key={part.id}>
                  <span
                    onClick={() => { setPartPictures(part.images); setPartPicturesOpen(true); }}
                    className="flex justify-center w-28 rounded-l-lg relative cursor-pointer bg-gray-400"
                  >
                    {imageUrl ? (
                      <img
                        className="w-full h-full object-contain rounded-l-lg"
                        src={imageUrl}
                      />
                    ) : (
                      <CameraIcon className="w-14 text-gray-600" />
                    )}
                  </span>

                  <div className="p-2 flex flex-col w-full">
                    <div className="flex justify-between relative">
                      <h1 className="ml-4 mb-1 font-semibold">{part.titleSanitised}</h1>
                    </div>

                    <div
                      className={innerColCss}
                    >
                      <div className="!border-l-0">
                        <span className="text-sm text-gray-500">Price</span>
                        <h1 className="text-lg">{PriceFormat(part.price)}</h1>

                        <span className="text-sm mt-1 text-gray-500">Make</span>
                        <h1>{part.vehicle?.combinedMake}</h1>
                      </div>
                      <div className="">
                        <span className="text-sm text-gray-500">OE Part Number</span>
                        <h1 className="text-lg">{part.oePartNumber ?? "N/A"}</h1>

                        <span className="text-sm mt-1 text-gray-500">Model</span>
                        <h1>{part.vehicle?.combinedModel}</h1>
                      </div>
                      <div className="">
                        <span className="text-sm text-gray-500">Part Number</span>
                        <h1 className="text-lg">{part.partNumber ?? "N/A"}</h1>

                        <span className="text-sm mt-1 text-gray-500">Reg</span>
                        <h1>{part.vehicle?.vrm}</h1>
                      </div>
                      <div className="">
                        <span className="text-sm text-gray-500">Sold</span>
                        {part.isInternal ? (
                          <h1 className="text-lg">{formatDateTime(part.soldDate, DateTime.DATE_SHORT, "Not Sold")}</h1>
                        ) : (
                          <h1 className="text-lg">{formatDateTime(part.created, DateTime.DATE_SHORT, "Not Sold")}</h1>
                        )}

                        <span className="text-sm mt-1 text-gray-500">Engine Code</span>
                        <h1>{part.vehicle?.engineModelCode}</h1>
                      </div>
                    </div>

                    {/* Extra row */}
                    {/* <div
                    className={innerColCss}
                  >
                    <div className="!border-l-0">

                    </div>
                    <div className="">

                    </div>
                    <div className="">

                    </div>
                    <div className="">

                    </div>
                  </div> */}

                  </div>

                </div>

              </div>
            )
          })}
      </div>
    </>
  );
}